import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import Imarika1 from "../../assets/Imarika1.png"

import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";

export default function ImarikaInvPlanTab3() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto mt-16 max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
          
            <p className="mt-6 text-base leading-7 ">

            Withdrawals before year 3 are subject to the early exit charges as follows;            </p>
            <p className="mt-6 text-base leading-7 ">
            Month 1 to Month 12 - 15% of the amount to be withdrawn,
            </p>
            <p className="mt-6 text-base leading-7 ">
            Month 13 to Month 24 – 10% of the amount to be withdrawn,
            </p>
            <p className="mt-6 text-base leading-7 ">
            Month 25 to Month 36 – 5% of the amount to be withdrawn,</p>
            <p className="mt-6 text-base leading-7 ">
            Month 37 and beyond– no charge.   </p>     
            <p className="mt-6 text-base leading-7 ">
            Imarika Charge: Management Fees: 0.33% per month

</p>
            <div className="mt-10 flex items-center gap-x-4">
     
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <img src={Imarika1} className="rounded-2xl  pt-20 "/>
             
             
          
          </div>
        </div>
      </div>
    </div>
  );
}
